import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

export const StyledFadeBlock = styled.div<{ gradientToTop?: boolean }>`
    position: absolute;
    width: 100%;
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        height: 60px;
        background: ${({ gradientToTop }) =>
            gradientToTop
                ? `linear-gradient(to top,
            ${rgba(colorsPalettes.bluegrey[100], 0)},
            ${colorsPalettes.bluegrey[100]} 50%,
            ${colorsPalettes.bluegrey[100]})`
                : `linear-gradient(to bottom,
            ${rgba(colorsPalettes.bluegrey[100], 0)},
            ${colorsPalettes.bluegrey[100]})`};
        pointer-events: none;
        z-index: 1069;
    }
`;
